import { useEffect, useState } from 'react';
import { PageSmallLoader } from '../../../component/PageLoader';
import productIcon from '../../../assets/image/product.svg';
import { fetchDashboardCardData } from '../../../services/dashboard';
import arrowDownBlackIcon from '../../../assets/image/arrow_down_dark.svg';
import { dateFilterOptions } from '../data';
import { addDays } from 'date-fns';

const SellingProducts = ({ card, isCustomizing, handleRemoveCard, filter }) => {
	const { title, layout_card_id } = card;
	const [productList, setProductList] = useState([]);
	const [showOptions, setShowOptions] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [localFilter, setLocalFilter] = useState({
		label: 'Today',
		filter_by: 'today',
	});

	const handleFetchTopSellingProductsData = async () => {
		try {
			setLoading(true);
			const payload = {
				filter_by: localFilter.filter_by,
			};
			if (
				localFilter.filter_by === 'custom_date' &&
				localFilter.start_date &&
				localFilter.end_date
			) {
				payload.start_date = localFilter.start_date;
				payload.end_date = localFilter.end_date;
			}

			const data = await fetchDashboardCardData(layout_card_id, payload);
			setProductList(data.top_selling_products);
		} catch (error) {
			console.error('Error fetching top selling products:', error);
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (option) => {
		if (option.value === 'custom_date') {
			setLocalFilter({
				label: option.label,
				filter_by: option.value,
				start_date: filter.start_date ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date: filter.end_date ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
		} else {
			setLocalFilter({
				label: option.label,
				filter_by: option.value,
			});
		}
		setShowOptions(false);
	};

	useEffect(() => {
		if (filter.filter_by === 'custom_date') {
			setLocalFilter({
				label: filter.label,
				filter_by: filter.filter_by,
				start_date: filter.start_date ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date: filter.end_date ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
		} else {
			setLocalFilter({
				label: filter.label,
				filter_by: filter.filter_by,
			});
		}
	}, [filter]);

	useEffect(() => {
		if (filter.filter_by === 'custom_date' && !filter.start_date && !filter.end_date) return;
		handleFetchTopSellingProductsData();
	}, [localFilter]);

	return (
		<div className="flex flex-col bg-white rounded-4 position-relative">
			{isCustomizing && (
				<div
					style={{
						position: 'absolute',
						top: -13,
						right: -13,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						width: '20px',
						height: '20px',
						backgroundColor: 'red',
						borderRadius: '50%',
						cursor: 'pointer',
						zIndex: 100,
					}}
					onTouchStart={(e) => {
						e.preventDefault();
						e.stopPropagation();
						handleRemoveCard(layout_card_id, e);
					}}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						handleRemoveCard(layout_card_id, e);
					}}
				>
					<div
						style={{
							color: '#000',
							fontSize: '16px',
							fontWeight: '600',
							lineHeight: '1',
							paddingBottom: '5px',
						}}
					>
						−
					</div>
				</div>
			)}

			<div className="px-3 py-3 d-flex justify-content-between grids-header-bg-color rounded-top-4">
				<h3 className="fs-4 font-semibold text-dark">{title}</h3>
				<div className="d-flex flex-row align-items-center gap-4">
					<div className="dropdown-container">
						<div
							className="select-box text-dark grids-header-bg-color fs-6"
							style={{ padding: '0px' }}
							onClick={() => setShowOptions(!showOptions)}
						>
							<div className="px-2">{localFilter.label}</div>
							<div className="mx-2">
								<img
									src={arrowDownBlackIcon}
									alt="arrow"
								/>
							</div>
						</div>

						{showOptions && (
							<ul className="options-list">
								{dateFilterOptions
									.filter((option) => option.value !== 'custom_date')
									.map((option, idx) => (
										<li
											key={idx}
											style={{ padding: '3px', zIndex: 1 }}
											onClick={() => handleChange(option)}
										>
											<div
												className={`${option.value === localFilter.filter_by ? 'text-secondary' : 'text-dark'} fs-6`}
											>
												{option.label}
											</div>
										</li>
									))}
							</ul>
						)}
					</div>
				</div>
			</div>

			{isLoading ? (
				<div className="d-flex justify-content-center align-items-center">
					<PageSmallLoader />
				</div>
			) : productList.length === 0 ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: '122px' }}
				>
					<p className="lead fs-5 text-center">No data found!</p>
				</div>
			) : (
				<div className="d-flex flex-row justify-content-center py-4 text-center px-4">
					{productList?.length > 0 ? (
						productList?.map((product) => {
							return (
								<div
									className="p-2 text-center"
									key={product.product_id + product.product_batch_id}
								>
									<img
										className="p-1"
										src={product.product_image || productIcon}
										alt={product.product_name}
										width={40}
										height={40}
									/>
									<div className="fs-5 font-semibold p-1">{product.product_name}</div>
									<div className="fs-6 font-semibold text-secondary">{`Qty - ${product.total_quantity_sold}`}</div>
								</div>
							);
						})
					) : (
						<></>
					)}
				</div>
			)}
		</div>
	);
};

export default SellingProducts;
